import { render, staticRenderFns } from "./grade-ii-listed-building-renovation.vue?vue&type=template&id=57b54650&"
import script from "./grade-ii-listed-building-renovation.vue?vue&type=script&lang=js&"
export * from "./grade-ii-listed-building-renovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports